import PropTypes from 'prop-types'
import React, { useEffect, useRef } from 'react'

const useOutsideClickHandler = (ref, onClose) => {
  useEffect(() => {
    function handleClickOutside(event) {
      setTimeout(() => {
        if (ref.current && !ref.current.contains(event.target)) {
          onClose()
        }
      }, 100)
    }
    document.addEventListener('mousedown', handleClickOutside)
    document.addEventListener('click', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
      document.removeEventListener('click', handleClickOutside)
    }
  }, [ref])
}

const OutsideClickHandler = ({ ref, onClose, children }) => {
  const wrapperRef = useRef(null)
  useOutsideClickHandler(wrapperRef, onClose)

  return <div ref={ref || wrapperRef}>{children}</div>
}

OutsideClickHandler.defaultProps = {
  ref: null,
}

OutsideClickHandler.propTypes = {
  ref: PropTypes.shape(),
  children: PropTypes.element.isRequired,
  onClose: PropTypes.func.isRequired,
}

export default OutsideClickHandler
